var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8596 17.9531L15.9532 21.0466L22.1404 14.8595M31.7188 17.5C31.7188 25.3528 25.3528 31.7188 17.5 31.7188C9.6472 31.7188 3.28125 25.3528 3.28125 17.5C3.28125 9.6472 9.6472 3.28125 17.5 3.28125C25.3528 3.28125 31.7188 9.6472 31.7188 17.5Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckCircle);
export default __webpack_public_path__ + "static/media/uncheck-circle.254ccbb860312c619bf8c25938415faf.svg";
export { ForwardRef as ReactComponent };